module.exports = __webpack_public_path__ + "img/fron-01.dc2e0516.jpg";